export default __webpack_public_path__ + "static/media/404.36ba75a0.png";